<div class="main-expansion-wrapper" *ngIf="pipeSpec">
    <mat-accordion multi="false">
        <mat-expansion-panel
            *ngFor="let item of pipeSpec?.versions; let i = index"
            [expanded]="!item?.pipeSpecVersionId"
            (expandedChange)="panelOpened($event, item)"
        >
            <mat-expansion-panel-header (click)="$event.stopPropagation(); $event.preventDefault()">
                <mat-panel-title (click)="$event.stopPropagation(); $event.preventDefault()">
                    {{ 'SETTING_PAGE.IDMS_SETTINGS.VERSION' | transloco }} - {{ item.version }}
                </mat-panel-title>

                <mat-icon style="margin-right: 10px" (click)="copyClicked($event)"
                    ><a
                        #tooltip="matTooltip"
                        matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.COPY' | transloco }}"
                        [matTooltipPosition]="tooltip_position"
                        *ngIf="item?.pipeSpecVersionId && createPipeCodes"
                        >file_copy</a
                    >
                </mat-icon>
                <mat-icon style="margin-right: 10px" (click)="deleteClicked($event)" *ngIf="!item?.pipeSpecVersionId && deletePipeCodes"
                    ><a #tooltip="matTooltip" matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DELETE' | transloco }}" [matTooltipPosition]="tooltip_position"
                        >delete</a
                    >
                </mat-icon>
            </mat-expansion-panel-header>
            <mat-panel-description>
                <!-- <div class="data-wrapper">
                <mat-checkbox class="" (change)="disableAll($event, item)"></mat-checkbox>Disable All
              </div> -->
                <div class="row">
                    <div class="col-xl-12" *ngIf="item && openedVersion == item">
                        <div class="row gx-5">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="group">
                                    <div class="group-title">{{ 'SETTING_PAGE.IDMS_SETTINGS.GENERAL' | transloco }}</div>
                                    <div class="inner-group">
                                        <app-pipe-code-general
                                            *ngIf="item"
                                            [enable]="item?.pipeSpecVersionId ? true : false"
                                            [pipeSpecVersion]="item"
                                            (SelectedcalculationType)="calcTypeHandler($event)"
                                            class="calculation-component"
                                        ></app-pipe-code-general>
                                    </div>
                                </div>

                                <div class="group">
                                    <div class="group-title">{{ 'SETTING_PAGE.IDMS_SETTINGS.CONTROLLED_TIGHTENING_PROCEDURE' | transloco }}</div>
                                    <div class="inner-group">
                                        <app-tightening-procedure-input
                                            [calculationType]="calculationType"
                                            [enable]="item?.pipeSpecVersionId ? true : false"
                                            [pipeSpecVersion]="item"
                                        ></app-tightening-procedure-input>
                                    </div>
                                </div>

                                <div class="group" *ngIf="item.calculationType == 0">
                                    <div class="group-title">{{ 'SETTING_PAGE.IDMS_SETTINGS.PROCESS_INFORMATION' | transloco }}</div>
                                    <div class="inner-group">
                                        <app-process-information-input
                                            [enable]="item?.pipeSpecVersionId ? true : false"
                                            [pipeSpecVersion]="item"
                                            [processInfoInput]="processInfoInput"
                                        ></app-process-information-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="group standard-flange-warp" [ngSwitch]="item.calculationType">
                                    <div *ngSwitchCase="0">
                                        <div class="group-title">{{ 'SETTING_PAGE.IDMS_SETTINGS.STANDARD_FLANGE' | transloco }}</div>
                                        <div class="inner-group">
                                            <app-flange-input
                                                [calculationType]="item.calculationType"
                                                [enable]="item?.pipeSpecVersionId ? true : false"
                                                [isPipeSpec]="true"
                                                [pipeSpecVersion]="item"
                                                (processInfo)="processInfoInputDataHandler($event)"
                                            ></app-flange-input>
                                        </div>
                                    </div>
                                    <div *ngSwitchCase="2">
                                        <div class="group-title">{{ 'PLANT_MANAGER.CLAMP' | transloco }}</div>
                                        <div class="inner-group">
                                            <app-clamp-input
                                                [calculationType]="item.calculationType"
                                                [enable]="item?.pipeSpecVersionId ? true : false"
                                                [pipeSpecVersion]="item"
                                            ></app-clamp-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-panel-description>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<!-- 
<div *ngSwitchCase="1">
        <app-clamp-input [pipeSpecVersion]="item" ></app-clamp-input>
</div>
<div *ngSwitchCase="2">
        <app-engineered-joint-input [pipeSpecVersion]="item"></app-engineered-joint-input>
</div> -->
